export default "__VITE_ASSET__DhyRxqGW__"